import React, {useState, useEffect} from "react";
import CustomDialog from "../../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../../core/components/common/custom-dialog-loader.component"
import useGatePassConfiguration from "../../hooks/useGatePassConfiguration";
import CustomTypography from "../../../../core/components/ui/CustomTypography";
import CustomTextField from "../../../../core/components/ui/CustomTextfield";
import EntryTypeDropdownComponent from "../../../GatePassPlugin/common/entry-type-dropdown.component";
import PassTypeDropdownComponent from "../../../GatePassPlugin/common/pass-type-dropdown.component";


const EditGatePassConfigurationDialog = (props) => {
    const {open, setOpen, selectedProfile} = props;

    const {viewProfileGatePassConfiguration, gatePassConfigurationDetails, isUpdatingGatePassConfiguration, updateProfileGatePassConfigurationDetails} = useGatePassConfiguration();

    const [selectedEntryType, setSelectedEntryType] = useState(null);
    const [selectedPassType, setSelectedPassType] = useState(null);

    
    useEffect(() => {
        const parameters = {
            profile_gatepass_type_uid: selectedProfile?.profile_gatepass_type_uid,
            role: selectedProfile?.role
        };
    
        viewProfileGatePassConfiguration(parameters);
    }, []);

    useEffect(() => {
       if (gatePassConfigurationDetails) {
            setSelectedEntryType(gatePassConfigurationDetails?.entry_type);
            setSelectedPassType(gatePassConfigurationDetails?.gatepass_type);
        }
    }, [gatePassConfigurationDetails]);


    const handleEntryTypeChange = (value) => {
        setSelectedEntryType(value);
    }

    const handlePassTypeChange = (value) => {
        setSelectedPassType(value);
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedEntryType(null);
        setSelectedPassType(null);
    }

    const handleEditGatePassConfiguration = (e) => {
        const parameters = {
            profile_gatepass_type_uid: selectedProfile?.profile_gatepass_type_uid,
            role: selectedProfile?.role,  
            entryType: selectedEntryType,
            gatepassType: selectedPassType,
        }
        
        updateProfileGatePassConfigurationDetails(parameters, setOpen);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: handleClose,
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (selectedEntryType && selectedPassType &&
                    (selectedEntryType !== gatePassConfigurationDetails?.entry_type || selectedPassType !== gatePassConfigurationDetails?.gatepass_type) &&
                    !isUpdatingGatePassConfiguration) ? handleEditGatePassConfiguration(e) : null,
            customStyles: {
                opacity: (selectedEntryType && selectedPassType &&
                    (selectedEntryType !== gatePassConfigurationDetails?.entry_type || selectedPassType !== gatePassConfigurationDetails?.gatepass_type) &&
                    !isUpdatingGatePassConfiguration) ? "100%" : "55%",
                cursor: (selectedEntryType && selectedPassType &&
                    (selectedEntryType !== gatePassConfigurationDetails?.entry_type || selectedPassType !== gatePassConfigurationDetails?.gatepass_type) &&
                    !isUpdatingGatePassConfiguration) ? "pointer" : "not-allowed !important",
                visibility: (isUpdatingGatePassConfiguration) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingGatePassConfiguration) ? null : handleClose}
                title="Edit Gate Pass Configuration"
                subtitle={"Modify gate pass configuration for profile"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingGatePassConfiguration) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating profile gate pass configuration..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Role"}
                                    customStyles={{
                                        //
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={selectedProfile?.role}
                                    variant={"outlined"}
                                    value={selectedProfile?.role}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                    readOnly={true}
                                    customStyles={{
                                        mb: 2
                                    }}
                                />

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Entry Type"}
                                    customStyles={{
                                        mb: (selectedEntryType) ? 2 : 1
                                    }}
                                />

                                <EntryTypeDropdownComponent
                                    value={selectedEntryType}
                                    onChange={handleEntryTypeChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> 

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Pass Type"}
                                    customStyles={{
                                        mb: (selectedPassType) ? 2 : 1,
                                        mt: 1.5
                                    }}
                                />

                                <PassTypeDropdownComponent
                                    value={selectedPassType}
                                    onChange={handlePassTypeChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingGatePassConfiguration && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default EditGatePassConfigurationDialog

